import api from './api';

class TierService {
  getListTier() {
    return api.post('/member/tier-info');
  }
}

export default new TierService();
